(() => {
  const studio = document.querySelector("[data-joiuss-saved-studio]");
  if (!studio) return;

  const empty = studio.querySelector("[data-joiuss-studio-empty]");
  const grid = studio.querySelector("[data-joiuss-studio-grid]");
  const toolbar = studio.querySelector("[data-saved-toolbar]");

  const safe = (v) => (v == null ? "" : String(v));

  // -------------------------------------
  // Compare mode + Prefetch helpers
  // -------------------------------------
  const MAX_COMPARE = 3;

  const compareState = {
    on: false,
    selected: new Map(), // handle -> { handle, title, url, image }
    prefetched: new Set(),
  };

  const prefetchUrl = (url) => {
    if (!url || compareState.prefetched.has(url)) return;
    compareState.prefetched.add(url);

    const link = document.createElement("link");
    link.rel = "prefetch";
    link.href = url;
    link.as = "document";
    document.head.appendChild(link);
  };

  const renderCompareTray = () => {
    const tray = document.querySelector("[data-compare-tray]");
    const items = document.querySelector("[data-compare-items]");
    const meta = document.querySelector("[data-compare-meta]");
    const go = document.querySelector("[data-compare-go]");
    if (!tray || !items || !meta || !go) return;

    const arr = Array.from(compareState.selected.values());
    tray.hidden = !(compareState.on && arr.length);

    items.innerHTML = arr
      .map((x) => {
        const title = safe(x.title);
        return `
          <button type="button" class="compare-pill" data-compare-pill data-handle="${safe(
            x.handle
          )}">
            ${
              x.image
                ? `<img src="${safe(x.image)}" alt="${title}" loading="lazy">`
                : ""
            }
            <span>${title}</span>
            <span aria-hidden="true">×</span>
          </button>
        `;
      })
      .join("");

    meta.textContent =
      arr.length < 2 ? "Pick 2–3 styles" : `Ready to compare ${arr.length} styles`;
    go.disabled = arr.length < 2;
  };

  const fetchCompareDetailsHTML = async (handle) => {
    const res = await fetch(`/products/${handle}?section_id=joiuss-compare-details`, {
      credentials: "same-origin",
    });
    if (!res.ok) return "";
    return await res.text();
  };

  // -------------------------------------
  // Remove individual saved style (event delegation)
  // -------------------------------------
  studio.addEventListener("click", (e) => {
    const removeBtn = e.target.closest("[data-remove-handle]");
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = removeBtn.getAttribute("data-remove-handle");
    if (!handle) return;

    if (
      window.JOIUSS_SAVED &&
      typeof window.JOIUSS_SAVED.remove === "function"
    ) {
      window.JOIUSS_SAVED.remove(handle);
    }
  });

  // -------------------------------------
  // Try-On (open the same modal as product page)
  // -------------------------------------
  const getSkuStrFromProduct = (product) => {
    const list =
      (product?.variants || [])
        .map((v) => (v && v.sku ? String(v.sku).trim() : ""))
        .filter(Boolean) || [];
    return Array.from(new Set(list)).join(",");
  };

    // Saved Try-On: prevent duplicate open() calls causing flicker
  let __joiussSavedTryOnInFlight = false;
  let __joiussSavedTryOnLastKey = "";
  let __joiussSavedTryOnLastAt = 0;


  const getDefaultSkuFromProduct = (product) => {
    const first = (product?.variants || []).find((v) => v && v.sku);
    return first && first.sku ? String(first.sku).trim() : "";
  };

  const openTryOnForHandle = async (handle, fallbackUrl) => {
    if (!window.JoiussTryOn || typeof window.JoiussTryOn.open !== "function") {
      if (fallbackUrl) window.location.href = fallbackUrl;
      return;
    }

        // Dedupe: block repeated opens for the same handle in a short window
    const now = Date.now();
    const key = String(handle || "").trim();

    if (__joiussSavedTryOnInFlight && key === __joiussSavedTryOnLastKey) return;
    if (key === __joiussSavedTryOnLastKey && now - __joiussSavedTryOnLastAt < 1200) return;

    __joiussSavedTryOnInFlight = true;
    __joiussSavedTryOnLastKey = key;
    __joiussSavedTryOnLastAt = now;


    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!res.ok) throw new Error("product json fetch failed");
      const product = await res.json();

    const defaultSku = getDefaultSkuFromProduct(product);
    // Saved page should behave like product page: single SKU only
    const skuStr = defaultSku;


      if (!skuStr) {
        __joiussSavedTryOnInFlight = false;
        if (fallbackUrl) window.location.href = fallbackUrl;
        return;
      }

      window.JoiussTryOn.open({
        skuStr,
        defaultSku,
        category: "saved",
      });

        // Release shortly after opening (covers modal init)
      setTimeout(() => {
        __joiussSavedTryOnInFlight = false;
      }, 800);
        } catch (err) {
      __joiussSavedTryOnInFlight = false;
      if (fallbackUrl) window.location.href = fallbackUrl;
    }

  };

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-joiuss-tryon-btn]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute("data-handle");
      const url = btn.getAttribute("data-url");

      if (!handle) {
        if (url) window.location.href = url;
        return;
      }

      openTryOnForHandle(handle, url);
    },
    true
  );

  // -------------------------------------
  // Fetch Liquid-rendered swatches for a product
  // -------------------------------------
  const fetchSwatchesHTML = async (handle) => {
    const res = await fetch(`/products/${handle}?section_id=joiuss-saved-swatches`, {
      credentials: "same-origin",
    });
    if (!res.ok) return "";
    return await res.text();
  };

  const renderBaseCard = (item) => {
    const title = item.title || item.handle.replace(/-/g, " ");
    const url = item.url || `/products/${item.handle}`;

    const tryonHTML =
      window.JOIUSS_SAVED?.buildTryonButtonHTML?.(item) ||
      `
        <button type="button"
                class="joiuss-btn joiuss-btn--primary joiuss-tryon-btn"
                data-joiuss-tryon-btn
                data-handle="${safe(item.handle)}"
                data-url="${safe(url)}"
        >Try on</button>
      `.trim();

    const card = document.createElement("div");
    card.className = "joiuss-studio-card";

    const titleSafe = safe(title);
    const urlSafe = safe(url);

    card.setAttribute("data-saved-card", "");
    card.setAttribute("data-handle", safe(item.handle));
    card.setAttribute("data-title", titleSafe);
    card.setAttribute("data-url", urlSafe);

    card.innerHTML = `
      <button
        class="joiuss-studio-card__remove"
        type="button"
        data-remove-handle="${safe(item.handle)}"
        aria-label="Remove from saved"
      >×</button>

      <label class="compare-check" data-compare-check hidden>
        <input type="checkbox" data-compare-checkbox aria-label="Add to compare">
        <span>Compare</span>
      </label>

      <div class="joiuss-studio-card__media">
        <div class="joiuss-studio-card__img skeleton"></div>
      </div>

      <h3 class="joiuss-studio-card__title">${safe(title)}</h3>

      <div class="joiuss-studio-card__swatches" data-swatches></div>

      <div class="joiuss-studio-card__actions">
        ${tryonHTML}
        <a class="joiuss-btn" href="${url}" data-view-details>View details</a>
      </div>
    `;

    return card;
  };

  const hydrateCard = (card, product) => {
    if (!product || !card) return;

    const imgWrap = card.querySelector(".joiuss-studio-card__img");
    if (imgWrap && product.featured_image) {
      imgWrap.outerHTML = `
        <img class="joiuss-studio-card__img"
             src="${product.featured_image}"
             alt="${safe(product.title)}">`;
    }

    const titleEl = card.querySelector(".joiuss-studio-card__title");
    if (titleEl && product.title) {
      titleEl.textContent = product.title;
    }

    if (product.featured_image) {
      card.setAttribute("data-image", product.featured_image);
    }
  };

  const render = async () => {
    if (!window.JOIUSS_SAVED || typeof window.JOIUSS_SAVED.readSaved !== "function")
      return;

    const saved = window.JOIUSS_SAVED.readSaved();

    grid.innerHTML = "";

    empty.hidden = saved.length !== 0;
    if (toolbar) toolbar.hidden = saved.length === 0;

    if (!saved.length) return;

    saved.forEach((item) => {
      grid.appendChild(renderBaseCard(item));
    });

    saved.forEach(async (item) => {
      const selector = `.joiuss-studio-card[data-handle="${CSS.escape(item.handle)}"]`;
      const card = grid.querySelector(selector);
      if (!card) return;

      try {
        const res = await fetch(`/products/${item.handle}.js`);
        if (res.ok) {
          const product = await res.json();
          hydrateCard(card, product);
        }
      } catch (e) {}

      try {
        const swatchHTML = await fetchSwatchesHTML(item.handle);
        const mount = card.querySelector("[data-swatches]");
        if (mount && swatchHTML) {
          mount.innerHTML = swatchHTML;
        }
      } catch (e) {}
    });
  };

  // -------------------------------------
  // Compare + Prefetch event wiring
  // -------------------------------------
  const bindCompareAndPrefetch = () => {
    document.addEventListener("click", (e) => {
      const toggle = e.target.closest("[data-compare-toggle]");
      if (!toggle) return;

      compareState.on = !compareState.on;
      toggle.setAttribute("aria-pressed", compareState.on ? "true" : "false");

      document.querySelectorAll("[data-saved-card]").forEach((card) => {
        const checkWrap = card.querySelector("[data-compare-check]");
        if (checkWrap) checkWrap.hidden = !compareState.on;

        if (!compareState.on) {
          const cb = card.querySelector("[data-compare-checkbox]");
          if (cb) cb.checked = false;
        }
      });

      if (!compareState.on) compareState.selected.clear();
      renderCompareTray();
    });

    document.addEventListener("change", (e) => {
      const cb = e.target.closest("[data-compare-checkbox]");
      if (!cb) return;

      const card = e.target.closest("[data-saved-card]");
      if (!card) return;

      const handle = card.getAttribute("data-handle");
      const title = card.getAttribute("data-title");
      const url = card.getAttribute("data-url");
      const image = card.getAttribute("data-image");

      if (cb.checked) {
        if (compareState.selected.size >= MAX_COMPARE) {
          cb.checked = false;
          return;
        }
        compareState.selected.set(handle, { handle, title, url, image });
      } else {
        compareState.selected.delete(handle);
      }

      renderCompareTray();
    });

    document.addEventListener("click", (e) => {
      const pill = e.target.closest("[data-compare-pill]");
      if (!pill) return;

      const handle = pill.getAttribute("data-handle");
      compareState.selected.delete(handle);

      const card = document.querySelector(
        `[data-saved-card][data-handle="${CSS.escape(handle)}"]`
      );
      if (card) {
        const cb = card.querySelector("[data-compare-checkbox]");
        if (cb) cb.checked = false;
      }

      renderCompareTray();
    });

    document.addEventListener("click", (e) => {
      const clear = e.target.closest("[data-compare-clear]");
      if (!clear) return;

      compareState.selected.clear();
      document
        .querySelectorAll("[data-compare-checkbox]")
        .forEach((cb) => (cb.checked = false));
      renderCompareTray();
    });

    document.addEventListener("click", (e) => {
      const go = e.target.closest("[data-compare-go]");
      if (!go) return;

      const arr = Array.from(compareState.selected.values());
      if (arr.length < 2) return;

      openCompareModal(arr);
    });

    const prefetchHandler = (e) => {
      const a = e.target.closest("a");
      if (!a) return;

      const isSwatchLink = a.closest("[data-swatches]");
      const isDetails = a.hasAttribute("data-view-details");
      if (!isSwatchLink && !isDetails) return;

      const href = a.getAttribute("href");
      if (!href || href.startsWith("#")) return;

      prefetchUrl(href);
    };

    document.addEventListener("mouseover", prefetchHandler, { passive: true });
    document.addEventListener("touchstart", prefetchHandler, { passive: true });
    document.addEventListener("focusin", prefetchHandler);

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-compare-close]")) return;
      closeCompareModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeCompareModal();
    });
  };

  function openCompareModal(selectedArr) {
    const modal = document.querySelector("[data-compare-modal]");
    const modalGrid = document.querySelector("[data-compare-modal-grid]");
    if (!modal || !modalGrid) return;

    modalGrid.innerHTML = selectedArr
      .map((item) => {
        const title = safe(item.title);
        const url = safe(item.url);
        const img = safe(item.image);

        return `
          <article class="joiuss-compare-modal__card">
            <a class="joiuss-compare-modal__img" href="${url}">
              ${img ? `<img src="${img}" alt="${title}" loading="lazy">` : ""}
            </a>

            <h3 class="joiuss-compare-modal__name">
              <a href="${url}">${title}</a>
            </h3>

            <div class="joiuss-compare-modal__details" data-compare-details data-handle="${safe(
              item.handle
            )}">
              <div class="joiuss-compare-modal__details-skeleton">Loading details…</div>
            </div>
          </article>
        `;
      })
      .join("");

    modal.hidden = false;

    selectedArr.forEach(async (item) => {
      const mount = document.querySelector(
        `[data-compare-details][data-handle="${CSS.escape(item.handle)}"]`
      );
      if (!mount) return;

      try {
        const html = await fetchCompareDetailsHTML(item.handle);
        mount.innerHTML = html
          ? html
          : `<div class="joiuss-compare-modal__details-empty">Details unavailable.</div>`;
      } catch (e) {
        mount.innerHTML = `<div class="joiuss-compare-modal__details-empty">Details unavailable.</div>`;
      }
    });

    document.documentElement.classList.add("joiuss-compare-modal-open");
  }

  function closeCompareModal() {
    const modal = document.querySelector("[data-compare-modal]");
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove("joiuss-compare-modal-open");
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindCompareAndPrefetch();
    render();
  });

  window.addEventListener("joiuss:saved-updated", () => {
    render();
    renderCompareTray();
  });
})();
